import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { Store } from '@ngrx/store';
import { LoggerService } from '@worktraq-app/core/logger';
import { pipe, switchMap, tap } from 'rxjs';
import { ThemeStore } from '~/shared-common';
import {
  setLoaded,
  setLoading,
  withCallState,
} from '~/shared-core/data-access';
import {
  companyDetailInitialState,
  companyDetailState,
  OPMCompanyWTListInitialState,
  CompanyWTListInitialState,
} from './models/company-wt.model';
import { OPMWTCompanyService } from './services/company-wt.service';

export const CompanyWTListStore = signalStore(
  { providedIn: 'root' },
  withState<companyDetailState>(companyDetailInitialState),
  withMethods(
    (
      store,
      reduxStore = inject(Store),
      opmWTCompanyService = inject(OPMWTCompanyService),
      logger = inject(LoggerService),
      themeStore = inject(ThemeStore),
    ) => ({
      getCompanyInfoByDomain: rxMethod<void>(
        pipe(
          tap(() => setLoading()),
          switchMap((params: any) =>
            opmWTCompanyService.getCompanyInfoByDomain(params).pipe(
              tapResponse({
                next: (rs: any) => {
                  patchState(store, {
                    company: rs,
                    ...setLoaded(),
                  });
                },
                error: () => {
                  patchState(store, {
                    ...companyDetailInitialState,
                    ...setLoaded(),
                  });
                },
              }),
            ),
          ),
        ),
      ),
      updateCompany: rxMethod(
        pipe(
          tap(() => setLoading()),
          switchMap((params: any) =>
            opmWTCompanyService.changeCompany(params).pipe(
              tapResponse({
                next: () => {
                  //
                },
                error: () => {
                  //
                },
              }),
            ),
          ),
        ),
      ),
      getCurrentCompanyDefaultRole: rxMethod(
        pipe(
          tap(() => setLoading()),
          switchMap((params: any) =>
            opmWTCompanyService.getCurrentCompanyDefaultRole(params).pipe(
              tapResponse({
                next: () => {
                  //
                },
                error: () => {
                  //
                },
              }),
            ),
          ),
        ),
      ),
      getWTCompanyList: rxMethod<void>(
        pipe(
          tap(() =>
            patchState(store, (state) => ({
              ...state,
              ...setLoading(),
            })),
          ),
          switchMap(() =>
            opmWTCompanyService
              .getSimpleList(OPMCompanyWTListInitialState.varQuery)
              .pipe(
                tapResponse({
                  next: (rs) => {
                    patchState(store, {
                      getListCompany: rs.getListCompany,
                      ...setLoaded(),
                    });
                  },
                  error: () => {
                    patchState(store, {
                      ...OPMCompanyWTListInitialState,
                      ...setLoaded(),
                    });
                  },
                }),
              ),
          ),
        ),
      ),
    }),
  ),
  withCallState(),
);
